<template>
  <div
    class="ca-wrapper"
    :class="{
      'ca-wrapper--hidden': !isCartOpen && isMobileView,
      'ca-wrapper--desktop': !isMobileView,
    }"
  >
    <!-- Single card that morphs between closed and open states -->
    <div class="ca-card" :class="isCartOpen ? 'ca-card--open' : 'ca-card--light'">

      <!-- Bet in revisione / riproposta / rifiutata: barra attaccata sopra il carrello -->
      <ReviewBarAmerican />

      <!-- ── HEADER AREA: fades between compact and open versions ────────── -->
      <transition name="ca-hdr" mode="out-in">

        <!-- Closed · single odd -->
        <div v-if="!isCartOpen && oddsLength === 1" key="h-single">
          <!-- Error strip -->
          <div v-if="hasErrors" class="ca-strip">
            <div v-if="showOddsUpdateMsg" class="ca-strip__line ca-strip__line--warn">{{ $t('updateOddsCart') }}</div>
            <div v-for="(e, i) in displayedErrorsMultiInfo" :key="'em'+i" class="ca-strip__line">{{ $t(e.message) }}</div>
            <div v-for="(e, i) in displayedErrors" :key="'e'+i" class="ca-strip__line ca-strip__line--err">{{ e.message.includes('#') ? getErrorDesc(e.message) : $t(e.message) }}</div>
            <div v-for="(w, i) in displayedWarnings" :key="'w'+i" class="ca-strip__line ca-strip__line--warn">{{ $t(w.message) }}</div>
          </div>
          <!-- Top: event info -->
          <div class="ca-single-top" :class="{ 'ca-single-top--disabled': isSingleOddDisabled }">
            <button class="ca-single-top__remove" @click="removeSingleOdd" v-if="!isBetConfirmed && !isUnderReview">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
            <div class="ca-single-top__info">
              <div class="ca-single-top__outcome">
                {{getOutcomeName(singleOdd)}} {{formatLineDisplay(singleOdd.line, singleOdd.id_market)}}

              </div>
              <div class="ca-single-top__market">{{ singleOdd.market_alias || singleOdd.market_name }}</div>
              <div class="ca-single-top__event">{{ singleOdd.event_description }}</div>
            </div>
            <div class="ca-single-top__odd" :class="{ 'ca-single-top__odd--changed': singleOdd.changed || isSingleOddUpdated }">
              {{ singleOdd.outcome_odd_value | odds_type_filter }}
              <OddBoostBadge :odd="singleOdd" size="sm"/>
            </div>
            <button class="ca-single-top__toggle" @click.stop="$emit('toggle-cart', true)">
              <div class="ca-single-top__toggle-inner">
                <IllinoisIcons icon="chevron-down" style="transform: rotate(180deg)" :width="14" :height="14" />
              </div>
            </button>
          </div>
          <!-- Bottom dark bar -->
          <div class="ca-single-bottom" v-if="!isBetConfirmed">
            <div class="ca-single-bottom__input-wrap">
              <span class="ca-single-bottom__label">{{ $t('bets.bet') }}</span>
              <div class="ca-single-bottom__amount-row">
                <span class="ca-single-bottom__currency">{{ getSettings.currencySymbol }}</span>
                <input
                  ref="singleAmountInput"
                  autocomplete="off"
                  :value="amountEditing ? amountDraft : formattedAmount"
                  type="text"
                  inputmode="decimal"
                  class="ca-single-bottom__input"
                  :disabled="isUnderReview"
                  @input="onAmountInput"
                  @focus="onAmountFocus"
                  @click="onAmountClick"
                  @keydown.enter="$event.target.blur()"
                  @blur="onAmountBlur"
                />
              </div>
            </div>
            <div class="ca-single-bottom__actions">
              <ActionsAmerican :inline-mode="true" @open-cart-pending="handleOpenCartPending" />
            </div>
          </div>
        </div>

        <!-- Closed · multiple odds -->
        <div v-else-if="!isCartOpen && oddsLength > 1" key="h-multi">
          <button class="ca-multi-header" @click="$emit('toggle-cart', true)">
            <div class="ca-multi-header__left">
              <div class="ca-badge">{{ oddsLength }}</div>
              <div class="ca-multi-header__info">
                <div class="ca-multi-header__title">{{ $t('selections') }}</div>
                <div class="ca-multi-header__names">
                  <span v-for="(odd, i) in odds" :key="odd.unique_id" class="ca-multi-header__name"
                        :class="{'is-unavailable': odd.to_remove,'is-suspended': odd.suspended && !odd.to_remove}">
                    {{getOutcomeName(odd)}} {{formatLineDisplay(odd.line, odd.id_market)}}<span v-if="i < odds.length - 1">,&nbsp;</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="ca-multi-header__right">
              <div v-if="getBet._multiple_detail.odds_total > 0 && !hasBBRedundant" class="ca-multi-header__total-odd">
                {{ getBet._multiple_detail.odds_total | odds_type_filter }}
              </div>
              <div class="ca-multi-header__toggle-wrap">
                <IllinoisIcons icon="chevron-down" style="transform: rotate(180deg)" :width="14" :height="14" />
              </div>
            </div>
          </button>
        </div>

        <!-- Confirmed bet · header -->
        <section v-else-if="isBetConfirmed && isCartOpen" key="h-confirmed">
          <div   class="ca-confirmed-header">
            <div class="ca-confirmed-header__left">
              <div class="ca-success-badge">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <span class="ca-confirmed-header__title">{{ $t('betPlaced') }}</span>

            </div>
            <div class="ca-confirmed-header__center">
            </div>
            <div class="ca-confirmed-header__right">
              <button class="ca-icon-btn" @click="printBet" :title="$t('print') || 'Stampa'">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/>
                </svg>
              </button>
              <button class="ca-icon-btn" @click="closeBet">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="ca-confirmed-subheader">
            <button class="ca-reuse-btn" @click="reuseSelections">
              {{ $t('reuseSelections') }}
            </button>
          </div>
        </section>



        <!-- Open · header -->
        <div v-else-if="isCartOpen" key="h-open" class="ca-open-header">
          <div class="ca-open-header__left">
            <div class="ca-open-header__title">
              <div class="ca-badge">{{ oddsLength }}</div>
              <span class="">{{ $t('selections') }}</span>
            </div>

            <button v-if="oddsLength > 0" class="ca-options-link" @click.stop="showOptions = !showOptions">
              {{ showOptions ? $t('hideOptions') : $t('showOptions') }}
            </button>
          </div>
          <div class="ca-open-header__right">
            <button class="ca-open-header__toggle" @click.stop="$emit('toggle-cart', false)">
              <div class="ca-open-header__toggle-inner">
                <IllinoisIcons icon="chevron-down" :width="14" :height="14" />
              </div>
            </button>
          </div>
        </div>

      </transition>

      <!-- ── BODY: height-animated expand/collapse ─────────────────────── -->
      <transition
        @before-enter="onBodyBeforeEnter"
        @enter="onBodyEnter"
        @after-enter="onBodyAfterEnter"
        @before-leave="onBodyBeforeLeave"
        @leave="onBodyLeave"
        @after-leave="onBodyAfterLeave"
      >
        <div v-if="isCartOpen" class="ca-body">

          <!-- ── Confirmed bet state ───────────────────────────────────────── -->
          <template v-if="isBetConfirmed">
            <div class="ca-content scroll-container ca-content--confirmed">
              <div class="ca-odds-container ca-odds-container--confirmed">
                <CartItemAmerican
                  v-for="odd in confirmedOdds"
                  :key="odd.unique_id"
                  :outcome-name="getOutcomeName(odd)"
                  :market-name="odd.market_alias || odd.market_name || ''"
                  :market-id="odd.id_market || odd.market_id || odd.marketId"
                  :event-name="odd.event_description || ''"
                  :odd-value="odd.outcome_odd_value"
                  :unique-id="odd.unique_id"
                  :specifier="getOddSpecifier(odd)"
                  :is-cart-open="true"
                  :bet-type="getConfirmedBet.type"
                  :readonly="true"
                  :boost-applied="odd.boostApplied === true"
                  :boost-percent="odd.boostPercent != null ? Number(odd.boostPercent) : null"
                  :early-payout="odd.earlyPayout === true"
                  :early-payout-margin="odd.earlyPayoutMargin != null ? Number(odd.earlyPayoutMargin) : null"
                />
              </div>
            </div>
            <div class="ca-confirmed-summary">
              <div class="ca-confirmed-summary__row">
                <span class="ca-confirmed-summary__label">{{ $t('bets.bet') || 'Importo giocato' }}</span>
                <span class="ca-confirmed-summary__value">{{ getSettings.currencySymbol }} {{ getConfirmedBet.amount | round_digits(2) }}</span>
              </div>
              <div class="ca-confirmed-summary__row ca-confirmed-summary__row--winning">
                <span class="ca-confirmed-summary__label">{{ $t('winning') || 'Vincita totale' }}</span>
                <span class="ca-confirmed-summary__value ca-confirmed-summary__value--winning">{{ getSettings.currencySymbol }} {{ getConfirmedBet.winning_total | round_digits(2) }}</span>
              </div>
            </div>
          </template>

          <!-- ── Normal cart state ─────────────────────────────────────────── -->
          <template v-else>
          <!-- DEV ONLY: mock confirmed bet -->
<!--          <button v-if="isDevMode && oddsLength > 0" class="ca-dev-mock-btn" @click="mockConfirmedBet">-->
<!--            🧪 Mock Bet Confirmed-->
<!--          </button>-->

          <!-- Options panel -->
          <div v-if="showOptions" class="ca-options">
            <div class="ca-options__row">
              <input id="ca-odds-var" type="checkbox" v-model="oddsVariation" class="ca-checkbox" />
              <label for="ca-odds-var">{{ $t('acceptAnyOdds') }}</label>
            </div>
          </div>



          <smart-toolbar-american
              class="ca-tabs"
              :groups="tabItems"
              :group-selected="activeTab"
              :tabs-scrollable="false"
              :show-expand-collapse="false"
              :show-search="false"
              :small-label="true"
              @update:groupSelected="onTabChange"
          />
          <div class="type-sel-cont" v-if="activeTab === 'cart' && oddsLength > 0 && !isUnderReview">
            <BetTypeSelectorAmerican />

          </div>


          <!-- Scrollable content -->
          <div class="ca-content scroll-container" ref="tabContent">
            <transition :name="'slide-' + transitionDirection" mode="out-in">
              <div v-if="activeTab === 'cart'">
                <div v-if="oddsLength === 0" class="ca-empty">
                  <div class="ca-empty__title">{{ $t('noOddsSelected') }}</div>
                  <div class="ca-empty__sub">{{ $t('noOddsSelectedHint') || $t('pleaseSelectOdd') }}</div>
                </div>
                <div v-else>
                  <v-progress-linear v-if="getLoading" indeterminate color="var(--color-primary)" style="margin: 0 0 4px;" />
                  <div class="ca-odds-container" :class="{ 'ca-odds-container--locked': isUnderReview }">
                    <template v-for="group in groupedOdds">
                      <!-- BET BUILDER group -->
                      <div v-if="group.is_bet_builder" :key="'bb-' + group.key" class="cia-bb-group">
                        <div class="cia-bb-label">
                          <svg xmlns="http://www.w3.org/2000/svg" width="35" height="14" viewBox="0 0 35 14"><rect width="30" height="14" rx="3" fill="var(--color-primary-light, #f90)"></rect><text x="15" y="10" text-anchor="middle" font-family="Arial,sans-serif" font-size="9" font-weight="900" fill="#000">SGP</text></svg>
                          combo
                        </div>
                        <div class="cia-bb-event-row">
                          <button v-if="!isUnderReview" class="cia-bb-remove" @click="removeBBGroup(group)">
                            <IllinoisIcons icon="close" height="16" width="16"/>
                          </button>
                          <span class="cia-bb-event-name">{{ group.event_description }}</span>
                          <span v-if="group.odds.some(o => o.bb_redundant || o.bb_unavailable)" class="cia-bb-unavailable">{{ $t('bb_odds_unavailable') }}</span>
                          <span v-else class="cia-bb-odd">{{ getBBOdd(group) | odds_type_filter }}</span>
                        </div>
                        <div class="cia-bb-timeline">
                          <div
                            v-for="(odd, idx) in group.odds"
                            :key="odd.unique_id"
                            class="cia-bb-row"
                            :class="{ 'cia-bb-row--last': idx === group.odds.length - 1, 'cia-bb-row--redundant': odd.bb_redundant_leg }"
                          >
                            <div class="cia-bb-dot"></div>
                            <div class="cia-bb-content">
                              <span class="cia-bb-outcome">{{ getOutcomeName(odd) }} {{formatLineDisplay(odd.line, odd.id_market)}}</span>
                              <span class="cia-bb-market">{{ odd.market_alias || odd.market_name }}</span>
                              <!-- Redundant selection named by the provider: say what covers it, remove it in one click -->
                              <span v-if="odd.bb_redundant_leg" class="cia-bb-redundant-leg-hint">
                                <v-icon x-small color="warning" class="mr-1">mdi-alert</v-icon>{{ redundantLegHint(group, odd) }}
                              </span>
                            </div>
                            <button v-if="odd.bb_redundant_leg" class="cia-bb-remove cia-bb-redundant-leg-remove" :aria-label="$t('remove')" @click="removeRedundantLeg(odd)">
                              <IllinoisIcons icon="close" height="14" width="14"/>
                            </button>
                          </div>
                        </div>
                        <!-- Provider momentarily unavailable: the group waits, the player retries -->
                        <div v-if="group.odds.some(o => o.bb_unavailable)" class="cia-bb-redundant-hint">
                          <v-icon x-small color="warning" class="mr-1">mdi-timer-sand</v-icon>
                          {{ $t('errors.betBuilderUnavailableReason') }}
                          <button type="button" class="cia-bb-retry-btn" @click="retryBetBuilder(group)">{{ $t('bb_retry') }}</button>
                        </div>
                        <div v-if="group.odds.some(o => o.bb_redundant)" class="cia-bb-redundant-hint">
                          <v-icon x-small color="warning" class="mr-1">mdi-alert</v-icon>
                          {{ $t('bb_remove_redundant') }}
                        </div>
                      </div>
                      <!-- Regular odd -->
                      <CartItemAmerican
                        v-else
                        :key="group.odds[0].unique_id"
                        :outcome-name="getOutcomeName(group.odds[0])"
                        :market-name="group.odds[0].market_alias || group.odds[0].market_name || ''"
                        :market-id="group.odds[0].id_market"
                        :event-name="group.odds[0].event_description || ''"
                        :odd-value="group.odds[0].outcome_odd_value"
                        :unique-id="group.odds[0].unique_id"
                        :specifier="getOddSpecifier(group.odds[0])"
                        :is-cart-open="true"
                        :bet-type="getBet.type"
                        :readonly="isUnderReview"
                        :boost-applied="group.odds[0].boostApplied === true"
                        :boost-percent="group.odds[0].boostPercent != null ? Number(group.odds[0].boostPercent) : null"
                        :early-payout="group.odds[0].earlyPayout === true"
                        :early-payout-margin="group.odds[0].earlyPayoutMargin != null ? Number(group.odds[0].earlyPayoutMargin) : null"
                      />
                    </template>
                    <SummaryAmerican />
                  </div>
                  <SummaryErrorsAmerican />
                </div>
              </div>
              <div v-else-if="activeTab === 'myBets'">
                <IllinoisMyBets
                  ref="illinoisMyBets"
                  @loading-change="onMyBetsLoadingChange"
                  @bets-loaded="onMyBetsLoaded"
                />
              </div>
              <!-- Cashout tab: IllinoisMyBets now carries its own cashout logic
                   (confirm → double-confirm → execute, plus the poller), ported
                   from MyBets.vue and sharing the same `cashout/` store module —
                   so it gets the same polling, request cap and badge statuses,
                   rendered with the Illinois/American card look instead of the
                   classic dark one. -->
              <!-- `cashout-only`: this tab is called Cashout, and a settled bet can
                   never be cashed out, so won and lost ones are filtered out. The
                   My Bets tab above renders the same component without the flag
                   and keeps listing every bet. -->
              <div v-else-if="activeTab === 'cashout'"><IllinoisMyBets cashout-only /></div>
            </transition>

          </div>

          <!-- Actions bar -->
          <div v-if="activeTab === 'cart' && oddsLength > 0" class="ca-actions-bar">
            <ActionsAmerican :inline-mode="true" @open-cart-pending="handleOpenCartPending" />
          </div>

          <!-- Load More bar (MyBets tab) -->
          <div
            v-if="activeTab === 'myBets' && showMyBetsLoadMore && !myBetsLoading && myBetsHasBets"
            class="ca-actions-bar"
          >
            <button class="ca-loadmore-btn" @click="openAllMyBets">
              {{ $t('loadmore') }}
              <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
          </div>

          </template><!-- end normal cart state -->

        </div>
      </transition>

    </div>

    <!-- Bet outcome modal -->
<!--    <BetOutcomeModalAmerican />-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isMobileOnly } from 'mobile-device-detect';
import ActionsAmerican         from './ActionsAmerican.vue';
import BetTypeSelectorAmerican from './BetTypeSelectorAmerican.vue';
import CartItemAmerican        from './CartItemAmerican.vue';
import SummaryAmerican         from './SummaryAmerican.vue';
import SummaryErrorsAmerican   from './SummaryErrorsAmerican.vue';
import ReviewBarAmerican       from './ReviewBarAmerican.vue';
import BetOutcomeModalAmerican from './BetOutcomeModalAmerican.vue';
import IllinoisMyBets from './IllinoisMyBets.vue';
import SmartToolbarAmerican from "@/components/american/SmartToolbarAmerican.vue";
import IllinoisIcons from "@/components/american/icons.vue";
import OddBoostBadge from "@/components/generic/OddBoostBadge.vue";
import {MARKET_ASIAN_HANDICAP} from "@/constants/marketConstants";

export default {
  name: 'CartAmerican',
  components: {
    IllinoisIcons,
    SmartToolbarAmerican,
    ActionsAmerican,
    BetTypeSelectorAmerican,
    CartItemAmerican,
    SummaryAmerican,
    SummaryErrorsAmerican,
    ReviewBarAmerican,
    BetOutcomeModalAmerican,
    IllinoisMyBets,
    OddBoostBadge,
  },
  props: {
    isCartOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobileView: isMobileOnly,
      activeTab: 'cart',
      showOptions: false,
      transitionDirection: 'right',
      myBetsLoading: true,
      myBetsHasBets: false,
      showMyBetsLoadMore: false,
      // Single-odd amount: while the field has focus it shows what the player types
      // (amountDraft), not the store value re-formatted on every key ("5" → "5,00").
      amountEditing: false,
      amountDraft: '',
      selectAmountOnClick: false,
    };
  },
  computed: {
    ...mapGetters({
      getBet:               'cart/getBet',
      getSettings:          'cart/getSettings',
      getLoading:           'cart/getLoading',
      getAuthenticated:     'user/getAuthenticated',
      getConfirmedBet:      'cart/getConfirmedBet',
      getPlatformSettings:  'settings/getPlatformSettings',
      getShortCode:         'settings/getShortCode',
      getOddsType:          'odds/getOddsType',
      getUserType:          'user/getType',
      getUserId:            'user/getId',
      getMarketConfig: 'settings/getMarketConfig',
      getCompetitorsInOutcome: 'settings/getCompetitorsInOutcome'
    }),
    odds() {
      return this.getBet.odds || [];
    },
    oddsLength() {
      return this.odds.length;
    },
    hasBBRedundant() {
      return this.odds.some(o => o.bb_redundant === true || o.bb_unavailable === true);
    },
    visibleOdds() {
      return this.odds.filter(o => !o.bet_builder_id);
    },
    groupedOdds() {
      const map = new Map();
      for (const odd of this.odds) {
        const key = odd.bet_builder_id || odd.unique_id;
        if (!map.has(key)) {
          map.set(key, {
            key,
            event_description: odd.event_description,
            is_bet_builder: !!odd.bet_builder_id,
            odds: [],
          });
        }
        map.get(key).odds.push(odd);
      }
      return Array.from(map.values());
    },
    singleOdd() {
      return this.oddsLength === 1 ? this.odds[0] : null;
    },
    singleOddLine() {
      if (!this.singleOdd) return null;
      const o = this.singleOdd;
      if (o.Line && o.BaseLine) {
        const needPlus = o.BaseLine != null &&
          String(o.BaseLine).slice(0, 1) === '-' &&
          String(o.Line).slice(0, 1) !== '-';
        return (needPlus ? '+' : '') + o.Line;
      }
      return null;
    },
    isSingleOddDisabled() {
      return this.singleOdd ? !!this.singleOdd.disabled : false;
    },
    isSingleOddUpdated() {
      return this.singleOdd ? !!this.singleOdd.changed : false;
    },
    formattedAmount() {
      const amount = this.getBet._multiple_detail?.amount || 0;
      return Number(amount).toFixed(2).replace('.', ',');
    },
    oddsVariation: {
      get() { return this.$store.getters['cart/getOddsVariation']; },
      set(value) { this.$store.dispatch('cart/setOddsVariation', value); },
    },
    // Bet in revisione o con riproposta da gestire: la schedina è bloccata
    isUnderReview() {
      const accepting = this.$store.getters['cart/getAcceptingBets'] || [];
      const changed   = this.$store.getters['cart/getAcceptedBetWithChange'] || [];
      return accepting.length > 0 || changed.length > 0;
    },
    // Esiti che richiedono l'attenzione dell'utente (riproposta / rifiuto)
    reviewOutcomeCount() {
      const changed  = this.$store.getters['cart/getAcceptedBetWithChange'] || [];
      const rejected = this.$store.getters['cart/getRejectedBets'] || [];
      return changed.length + rejected.length;
    },
    getCashoutEnabled() {
      return this.$store.getters['settings/getCashout'] || this.$store.getters['settings/getCashoutLive'] || false;
    },
    tabItems() {
      const items = [];
      items.push({ label: this.$t('cart_ill'), name: this.$t('cart_ill'), value: 'cart' , _id: 'cart' });
      items.push({ label: this.$t('myBets'), name: this.$t('myBets'), value: 'myBets',  _id: 'myBets' });
      if (this.getAuthenticated && this.getCashoutEnabled) {
        items.push({ label: this.$t('Cashout'), name: this.$t('Cashout'), value: 'cashout',  _id: 'cashout' });
      }
      return items;
    },
    isDevMode() {
      return process.env.NODE_ENV !== 'production';
    },
    isBetConfirmed() {
      return !!this.getConfirmedBet && !this.getConfirmedBet.is_booked
        && Array.isArray(this.getConfirmedBet.odds) && this.getConfirmedBet.odds.length > 0;
    },
    confirmedOdds() {
      return (this.getConfirmedBet?.odds || []).filter(o => !o.bet_builder_id);
    },
    // Errors for the single-odd strip
    cartErrors() { return this.getBet.errors || []; },
    cartWarningsStore() { return this.getBet.warnings || []; },
    displayedErrors() { return this.cartErrors.filter(e => e.type === 'error'); },
    displayedWarnings() {
      return this.cartErrors.filter(e => e.type === 'warning').concat(this.cartWarningsStore);
    },
    displayedErrorsMultiInfo() {
      return this.cartErrors.filter(e => e.type === 'multiInfo' || e.type === 'info');
    },
    showOddsUpdateMsg() { return this.odds.some(o => o.changed); },
    hasErrors() {
      return (
        this.showOddsUpdateMsg ||
        this.displayedErrors.length > 0 ||
        this.displayedWarnings.length > 0 ||
        this.displayedErrorsMultiInfo.length > 0
      );
    },
  },
  methods: {
    ...mapActions({
      refreshCart:      'cart/refreshCart',
      initCartV2:       'cart/initCartV2',
      resetCart:        'cart/resetCart',
      clearConfirmedBet: 'cart/clearConfirmedBet',
    }),
    stripScoreState(str, market) {
      if (!str) return str;

      let st = String(str).replace(/\s*\(\d+-\d+\)\s*$/, '').trim();

      if (MARKET_ASIAN_HANDICAP.includes(market) && !st.startsWith('-'))
        return '+' + st;

      return st
    },
    formatLineDisplay(line, market) {
      if (!line) return '';
      let str = this.stripScoreState(String(line).trim());

      if (this.isHandicapMarket(market)) {
        if (/^[0-9]/.test(str) && parseFloat(str) !== 0) {
          return '+' + str;
        }
      }

      if (MARKET_ASIAN_HANDICAP.includes(market) && !str.startsWith('-'))
        return '+' + str;

      return str;
    },
    isHandicapMarket(market) {
      if (!market) return false;
      const id = parseInt( market, 10);
      return this.getMarketConfig.handicapIds.includes(id);
    },
    onBodyBeforeEnter(el) {
      el.style.height = '0';
    },
    onBodyEnter(el, done) {
      void el.offsetHeight; // forza reflow per attivare la CSS transition
      el.style.height = el.scrollHeight + 'px';
      setTimeout(done, 300);
    },
    onBodyAfterEnter(el) {
      el.style.height = 'auto';
    },
    onBodyBeforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    onBodyLeave(el, done) {
      // Forza il reflow
      void el.offsetHeight;
      el.style.height = '0';
      setTimeout(done, 300);
    },
    onBodyAfterLeave(el) {
      el.style.height = '';
    },
    getOutcomeName(odd) {
      const name = odd.outcome_name;
      if (!name) return odd.outcome_alias || '';
      if (name === 'X') return odd.outcome_alias || odd.outcome_name;
      const lower = name.toLowerCase();
      const c = odd.competitors;
      if (this.getCompetitorsInOutcome) {
        if (lower === 'local' && c && c[0]) return c[0].name;
        if (lower === 'visitante' && c && c[1]) return c[1].name;
        if ((name === '1' || name === '2') && c) {
          const found = c.find(t => t.position === name);
          if (found) return found.name;
        }
      }
      return odd.outcome_alias || name;
    },
    getBBOdd(group) {
      const main = group.odds.find(o => parseFloat(o.outcome_odd_value) !== 1);
      return main ? main.outcome_odd_value : (group.odds[0] ? group.odds[0].outcome_odd_value : 0);
    },
    // "Already covered by Newcastle Jets FC (1X2): remove this selection"; the generic
    // text when the covering selection is not in the group.
    redundantLegHint(group, odd) {
      const by = group.odds.find(o => String(o.unique_id) === String(odd.bb_implied_by));
      if (!by) return this.$t('bb_remove_redundant');
      return this.$t('bb_redundant_leg', {selection: `${this.getOutcomeName(by)} (${by.market_alias || by.market_name})`});
    },
    // Removing the redundant leg re-quotes the rest of the group (removeOddFromCart).
    async removeRedundantLeg(odd) {
      await this.$store.dispatch('cart/removeOddFromCart', { unique_id: odd.unique_id });
      await this.$store.dispatch('cart/refreshCart');
    },
    retryBetBuilder(group) {
      this.$store.dispatch('cart/retryBetBuilderGroup', { eventSource: group.odds[0].event_source });
    },
    async removeBBGroup(group) {
      for (const odd of group.odds) {
        await this.$store.dispatch('cart/removeOddFromCart', { unique_id: odd.unique_id, skipBetBuilderRecalc: true });
      }
      await this.$store.dispatch('cart/refreshCart');
    },
    getOddSpecifier(odd) {
      if (odd.line && odd.line !== '') return odd.line;
      if (odd.baseLine && odd.baseLine !== '') return odd.baseLine;
      if (odd.specifiers && odd.specifiers !== '') {
        const part = odd.specifiers.split(' ')[0];
        const c = part.charAt(0);
        return (isNaN(c) && c !== '-' && c !== '+') ? null : part;
      }
      return null;
    },
    onAmountFocus(e) {
      this.amountEditing = true;
      this.amountDraft = this.formattedAmount;
      this.selectAmountOnClick = true;
      // Keyboard focus (Tab): select now; a mouse focus is selected again in onAmountClick,
      // since the mouseup that follows would drop this selection on some browsers.
      this.$nextTick(() => e.target.select());
    },
    // A click selects the whole amount, so typing replaces it. Once everything is
    // selected, a second click places the caret as usual; after typing, a click selects all again.
    onAmountClick(e) {
      if (!this.selectAmountOnClick) return;
      this.selectAmountOnClick = false;
      e.target.select();
    },
    onAmountInput(e) {
      // Keep the separator the player typed (',' or '.'), at most one, at most 2 decimals.
      let draft = e.target.value.replace(/[^0-9.,]/g, '');
      const sep = draft.search(/[.,]/);
      if (sep !== -1) {
        draft = draft.slice(0, sep + 1) + draft.slice(sep + 1).replace(/[.,]/g, '').slice(0, 2);
      }
      if (draft !== e.target.value) e.target.value = draft;
      this.amountDraft = draft;
      this.selectAmountOnClick = true;
      const num = parseFloat(draft.replace(',', '.')) || 0;
      if (this.getBet._multiple_detail) this.getBet._multiple_detail.amount = num;
      this.refreshCart();
    },
    onAmountBlur() {
      this.amountEditing = false;
      this.selectAmountOnClick = false;
      const amount = this.getBet._multiple_detail?.amount || 0;
      const min = this.getSettings.minAmount || 0;
      const final = Math.max(min, Number(amount));
      if (this.getBet._multiple_detail) {
        this.getBet._multiple_detail.amount = parseFloat(final.toFixed(2));
      }
      this.refreshCart();
    },
    removeSingleOdd() {
      if (this.singleOdd) {
        this.$store.dispatch('cart/removeOddFromCart', { unique_id: this.singleOdd.unique_id });
      }
    },
    handleOpenCartPending() {
      if (!this.isCartOpen) this.$emit('toggle-cart', true);
      this.activeTab = 'cart';
    },
    onTabChange(tab) {
      const tabValues = this.tabItems.map(t => t.value);
      const curIdx = tabValues.indexOf(this.activeTab);
      const newIdx = tabValues.indexOf(tab);
      this.transitionDirection = newIdx > curIdx ? 'right' : 'left';
      this.activeTab = tab;
      this.showMyBetsLoadMore = tab === 'myBets';
    },
    openAllMyBets() {
      this.$root.$emit('openBetListModal');
    },
    onMyBetsLoadingChange(loading) {
      this.myBetsLoading = loading;
    },
    onMyBetsLoaded(hasBets) {
      this.myBetsHasBets = hasBets;
      if (hasBets && this.activeTab === 'myBets') {
        this.showMyBetsLoadMore = true;
      }
    },
    getErrorDesc(message) {
      const split = message.split('#');
      return split[0] + ' ' + this.$t(split[1]);
    },
    mockConfirmedBet() {
      const b = this.getBet;
      const amount = b._multiple_detail?.amount || 10;
      const winning = b._multiple_detail?.winning || amount * (b._multiple_detail?.odds_total || 2);
      this.$store.dispatch('cart/setConfirmedBet', {
        bet_code: 'MOCK-' + Date.now(),
        is_booked: false,
        type: b.type,
        amount,
        odds_total: b._multiple_detail?.odds_total || 0,
        winning,
        winning_total: winning,
        bonus: 0,
        bonus_percentage: 0,
        odds: JSON.parse(JSON.stringify(b.odds)),
      });
    },
    reuseSelections() {
      this.clearConfirmedBet();
    },
    printBet() {
      const code = this.getConfirmedBet?.bet_code;
      if (!code || !this.getPlatformSettings?.print_endpoint) return;
      const base = this.getPlatformSettings.print_endpoint + code;
      const url = this.getShortCode
        ? `${base}&login=${this.getUserType}&ancestors=${this.getUserId}&type_odd=${this.getOddsType}`
        : `${base}&type_odd=${this.getOddsType}`;
      window.open(url, '_blank', 'height=600,width=350');
    },
    async closeBet() {
      await this.resetCart();
      this.$emit('toggle-cart', false);
    },
  },
  watch: {
    isCartOpen(newVal) {
      if (!newVal) this.showOptions = false;
    },
    // Su mobile il carrello chiuso è nascosto: lo apriamo per mostrare la barra
    reviewOutcomeCount(newVal, oldVal) {
      if (newVal > oldVal && this.isMobileView && !this.isCartOpen) {
        this.$emit('toggle-cart', true);
      }
      if (newVal > oldVal) this.activeTab = 'cart';
    },
    isBetConfirmed(newVal) {
      if (newVal && !this.isCartOpen) {
        this.$emit('toggle-cart', true);
      }
    },
  },
  async mounted() {
    await this.initCartV2();
    this.$root.$on('sectionCart', () => { this.activeTab = 'cart'; });
  },
};
</script>

<style scoped>
/* ── Wrapper (fixed bottom) ──────────────────────────────────────────────── */
.ca-wrapper {
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  z-index: 1002;
  display: flex;
  justify-content: center;
  max-height: calc(100vh - 60px);
}
/* Hidden on mobile when closed (like Illinois) */
.ca-wrapper--hidden {
  display: none;
}
/* Desktop: 40px from bottom (Illinois: md991:bottom-10) */
@media (min-width: 991px) {
  .ca-wrapper--desktop {
    bottom: 40px;
  }
  .ca-card{
    width: 28rem!important;
    border-radius: .375rem;


  }
}



/* ── Generic badge ───────────────────────────────────────────────────────── */
.ca-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  color: #ffffff;
  font-size: var(--font-size-2xl);
  font-weight: 700;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── Generic chevron ─────────────────────────────────────────────────────── */
.ca-chevron { transition: transform 0.3s ease; flex-shrink: 0; }
.ca-chevron--up   { transform: rotate(180deg); }
.ca-chevron--down { transform: rotate(0deg); }

/* ══════════════════════════════════════════════════════════════════════════ */
/* CARD (shared wrapper for collapsed states)                                  */
/* ══════════════════════════════════════════════════════════════════════════ */
.ca-card {
  overflow: hidden;
  box-shadow: 0 -4px 24px rgba(0,0,0,0.45);
  background: var(--bg-cart);
  width: 100%;
}
/* Illinois: collapsed card is WHITE with rounded top corners */
.ca-card--light {
  background: #ffffff;
  border-radius: 8px 8px 0 0;
}
@media (min-width: 991px) {
  .ca-card--light { border-radius: 8px; }
}

/* ══════════════════════════════════════════════════════════════════════════ */
/* CLOSED · SINGLE ODD                                                         */
/* ══════════════════════════════════════════════════════════════════════════ */

/* Error strip (bg: primary) */
.ca-strip {
  background: var(--color-primary);
  padding: 6px 10px;
  border-radius: 8px 8px 0 0;
}
.ca-strip__line {
  font-size: var(--font-size-2xl);
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 2px;
}
.ca-strip__line--warn { color: #fbbf24; }
.ca-strip__line--err  { color: #fca5a5; }

/* Top white section (Illinois: bg-illinois-text p-2.5 flex items-start justify-between) */
.ca-single-top {
  background: #ffffff;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
  position: relative;
}
.ca-single-top--disabled { opacity: 0.5; }

.ca-single-top__remove {
  background: none;
  border: none;
  cursor: pointer;
  color: #00000080; /* illinois-black-50 */
  padding: 4px;
  padding-top: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  transition: color 0.15s;
  z-index: 1;
}
.ca-single-top__remove:hover { color: var(--color-primary); }

.ca-single-top__info {
  flex: 1;
  min-width: 0;
  padding-left: 8px;
}
/* Illinois: text-lg font-bold text-illinois-primary */
.ca-single-top__outcome {
  font-size: var(--font-size-7xl);
  font-weight: 700;
  color: var(--color-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ca-single-top__line {
  font-size: var(--font-size-3xl);
  font-weight: 400;
  color: #00000080;
  margin-left: 4px;
}
/* Illinois: text-sm text-illinois-black font-bold */
.ca-single-top__market {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Illinois: text-sm text-illinois-black-50 */
.ca-single-top__event {
  font-size: var(--font-size-3xl);
  color: #00000080;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Illinois: px-2 py-1 rounded text-base font-bold */
.ca-single-top__odd {
  font-size: var(--font-size-5xl);
  font-weight: 700;
  color: #1a1a1a;
  padding: 4px 8px;
  border-radius: 4px;
  flex-shrink: 0;
  align-self: flex-start;
  margin-top: 2px;
}
.ca-single-top__odd--changed {
  background: #eab308; /* yellow-500 */
  color: #1a1a1a;
}

/* Illinois: inline-flex items-center justify-center gap-1 w-10 h-10 */
.ca-single-top__toggle {
  background: none;
  border: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
}
/* Illinois: text-xs h-full w-full flex items-center justify-center border-illinois-black-10 border-l */
.ca-single-top__toggle-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #0000001a;
  color: #00000080;
}

/* Bottom dark bar (Illinois: bg-illinois-bg-dropdown flex items-center) */
.ca-single-bottom {
  display: flex;
  align-items: stretch;
  background: #2a2a2a; /* dark dropdown */
  height: 56px;
}

/* Illinois: w-1/2 cart-input-wrapper bg-illinois-dark h-14 */
.ca-single-bottom__input-wrap {
  width: 50%;
  background: #1a1a1a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 10px;
  border: 2px solid transparent;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
/* Illinois: text-xs text-illinois-text px-2.5 font-semibold capitalize */
.ca-single-bottom__label {
  font-size: var(--font-size-xl);
  font-weight: 600;
  color: #ffffff;
  text-transform: capitalize;
  line-height: 1;
  margin-bottom: 3px;
}
.ca-single-bottom__amount-row {
  display: flex;
  align-items: center;
  height: 20px;
}
/* Illinois: text-yellow-500 font-bold pl-2.5 single-odd-currency-symbol (19px) */
.ca-single-bottom__currency {
  font-size: var(--font-size-7xl);
  font-weight: 700;
  color: #eab308;
  line-height: 1;
}
/* Illinois: text-left flex-1 bg-transparent text-yellow-500 single-odd-amount-input (19px bold) */
.ca-single-bottom__input {
  background: transparent;
  border: none;
  outline: none;
  font-size: var(--font-size-7xl);
  font-weight: 700;
  color: #eab308;
  width: 100%;
  padding: 0 0 0 4px;
  line-height: 1;
}
.ca-single-bottom__input::placeholder { color: rgba(255,255,255,0.25); }
.ca-single-bottom__input:disabled { opacity: 0.5; cursor: not-allowed; }
.ca-odds-container--locked { pointer-events: none; opacity: 0.6; }

/* Illinois: w-1/2 h-14 */
.ca-single-bottom__actions {
  width: 50%;
  height: 56px;
  display: flex;
}

/* ══════════════════════════════════════════════════════════════════════════ */
/* CLOSED · MULTIPLE ODDS                                                      */
/* ══════════════════════════════════════════════════════════════════════════ */
.ca-multi-header {
  width: 100%;
  background: #ffffff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 10px;
  text-align: left;
}
.ca-multi-header__left {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
.ca-multi-header__info {
  flex: 1;
  min-width: 0;
}
/* Illinois: text-base font-bold leading-5 */
.ca-multi-header__title {
  font-size: var(--font-size-5xl);
  font-weight: 700;
  color: #1a1a1a;
  line-height: 20px;
  text-transform: capitalize;
}
/* Illinois: flex flex-wrap items-center gap-2 px-1 pt-1 */
.ca-multi-header__names {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 4px 4px 0;
  min-width: 0;
}
/* Illinois: text-sm text-illinois-primary font-bold */
.ca-multi-header__name {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--color-primary);
  white-space: nowrap;
}
.ca-multi-header__name.is-suspended, .ca-multi-header__name.is-unavailable{
  opacity: 0.5;
}
.ca-multi-header__right {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-shrink: 0;
}
/* Illinois: w-8 h-10 border-illinois-black-10 border-l */
.ca-multi-header__total-odd {
  font-size: var(--font-size-5xl);
  font-weight: 800;
  color: var(--color-primary);
  padding-right: 8px;
  white-space: nowrap;
}
.ca-multi-header__toggle-wrap {
  width: 32px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #0000001a;
  color: #00000080;
}

/* ══════════════════════════════════════════════════════════════════════════ */
/* OPEN STATE                                                                   */
/* ══════════════════════════════════════════════════════════════════════════ */
.ca-open {
  background: var(--bg-cart, #2a2a2a);
  border-radius: 8px 8px 0 0;
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  overflow: hidden;
  box-shadow: 0 -4px 24px rgba(0,0,0,0.45);
}
@media (min-width: 991px) {
  .ca-open {
    border-radius: 8px;
    max-height: calc(100vh - 80px);
  }
}

/* Illinois: text-sm flex items-start gap-2 p-2.5 border-b sticky top-0 */
.ca-open-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px;
  border-bottom: 1px solid #0000001a;
  position: sticky;
  top: 0;
  background: var(--bg-cart);
  z-index: 2;
  cursor: pointer;
  user-select: none;
}
.ca-open-header__left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
}
/* Illinois: text-base font-bold leading-5 */
.ca-open-header__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-5xl);
  font-weight: 700;
  color: var(--text-cart, #ffffff);
  line-height: 20px;
  text-transform: capitalize;
}
.ca-open-header__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
/* Illinois: text-illinois-primary text-sm hover:underline */
.ca-options-link {
  background: none;
  border: none;
  cursor: pointer;
  font-size: var(--font-size-3xl);
  color: var(--color-primary);
  text-decoration: none;
  padding: 0;
}
.ca-options-link:hover { text-decoration: underline; }

/* Illinois: w-8 h-10 */
.ca-open-header__toggle {
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.ca-open-header__toggle-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-cart, rgba(255,255,255,0.5));
}

/* Options panel */
.ca-options {
  padding: 10px;
  border-bottom: 1px solid rgba(255,255,255,0.07);
  flex-shrink: 0;
}
.ca-options__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  cursor: pointer;
}
.ca-options__row label {
  font-size: var(--font-size-3xl);
  color: var(--text-cart, #ffffff);
  cursor: pointer;
  user-select: none;
}
.ca-checkbox {
  accent-color: var(--color-primary);
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* Tab bar */
.ca-tabs {
  display: flex;
  border-bottom: 1px solid var(--color-accent);
  padding: 4px 10px;
  flex-shrink: 0;
  border-radius: 0;
}

.ca-tab {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-size: var(--font-size-2xl);
  font-weight: 500;
  color: var(--text-op-50-platform, rgba(255,255,255,0.5));
  padding: 10px 10px 10px 0;
  margin-right: 4px;
  transition: color 0.15s, border-color 0.15s;
  white-space: nowrap;
  text-transform: capitalize;
}
.ca-tab--active {
  color: var(--text-platform, #ffffff);
  font-weight: 700;
  border-bottom-color: var(--color-primary);
}
.ca-tab--disabled { opacity: 0.4; cursor: not-allowed; }

/* Scrollable content — Illinois: overflow-y-auto tab-content-wrapper scroll-container */
.ca-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
  transition: padding 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: calc(100vh - 275px);
}
.ca-content--confirmed {
  padding: 0;
  gap: 0;
  max-height: 400px;
  min-height: auto!important;
}
@media (min-width: 991px) {
  .ca-content { min-height: 400px; }
  .ca-content { max-height: 500px; }
}

/* Thin scrollbar (Illinois style) */
.scroll-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(74,74,74,0.5) transparent;
  -webkit-overflow-scrolling: touch;
}
.scroll-container::-webkit-scrollbar { width: 2px; }
.scroll-container::-webkit-scrollbar-track { background: transparent; }
.scroll-container::-webkit-scrollbar-thumb { background: rgba(74,74,74,0.4); border-radius: 1px; }
.scroll-container:hover::-webkit-scrollbar { width: 3px; }
.scroll-container:hover::-webkit-scrollbar-thumb { background: rgba(74,74,74,0.6); }

/* Illinois: flex flex-col rounded-md pt-6 bg-illinois-text m-2.5 mt-0 border border-illinois-black-10 */
.ca-odds-container {
  background: var(--bg-odd-cart);
  border-radius: 8px;
  border: 1px solid #0000001a;
  padding: 18px .625rem;
  margin: 0 0 6px;
  transition: border-radius 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              border-color 0.35s ease,
              padding 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              margin 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.ca-odds-container--confirmed {
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-top: none;
  padding: 10px .625rem;
  margin: 0;
}

/* Empty state */
.ca-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #0000001a;
  margin: 0 0 6px;
  text-align: center;
}
.ca-empty__title {
  font-size: var(--font-size-5xl);
  font-weight: 700;
  color: var(--color-primary);
}
.ca-empty__sub {
  font-size: var(--font-size-3xl);
  color: #00000080;
}

/* Fixed bottom actions bar (Illinois: h-14 overflow-hidden flex-shrink-0) */
.ca-actions-bar {
  flex-shrink: 0;
  height: 56px;
  overflow: hidden;
}

.ca-loadmore-btn {
  width: 100%;
  height: 56px;
  background: var(--color-primary);
  color: #ffffff;
  border: none;
  cursor: pointer;
  font-size: var(--font-size-4xl);
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: opacity 0.15s;
}
.ca-loadmore-btn:hover { opacity: 0.9; }

/* ══════════════════════════════════════════════════════════════════════════ */
/* TRANSITION                                                                   */
/* ══════════════════════════════════════════════════════════════════════════ */
.cart-view-enter-active,
.cart-view-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.cart-view-enter,
.cart-view-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

/* Animazione altezza ca-body */
.ca-body {
  transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: height;
}

/* Transizione Header (ca-hdr) */
.ca-hdr-enter-active,
.ca-hdr-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.ca-hdr-enter,
.ca-hdr-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Transizione Slide Orizzontale dei Tab */
.slide-left-enter-active, .slide-right-enter-active,
.slide-left-leave-active, .slide-right-leave-active {
  transition: all 0.25s ease-out;
}
.slide-right-enter { opacity: 0; transform: translateX(100%); }
.slide-right-leave-to { opacity: 0; transform: translateX(-100%); }
.slide-left-enter { opacity: 0; transform: translateX(-100%); }
.slide-left-leave-to { opacity: 0; transform: translateX(100%); }

.type-sel-cont{
  padding: 0 .625rem;
  border-bottom: 1px solid rgba(0,0,0,.10196078431372549);
}

/* ══════════════════════════════════════════════════════════════════════════ */
/* CONFIRMED BET STATE                                                         */
/* ══════════════════════════════════════════════════════════════════════════ */
.ca-confirmed-subheader {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 6px 10px;
  background: var(--bg-odd-cart);
  border-bottom: 1px solid rgba(0,0,0,0.1);
}
.ca-reuse-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: var(--font-size-2xl);
  color: var(--color-primary);
  padding: 4px 0;
  text-underline-offset: 2px;
  transition: opacity 0.15s;
}
.ca-reuse-btn:hover { opacity: 0.75; }

.ca-confirmed-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: var(--win-bg);
  border-bottom: 1px solid rgba(0,0,0,0.1);
  gap: 8px;
  transition: background 0.3s ease;
}
.ca-confirmed-header__left  { flex-shrink: 0;display: flex;align-items: center;gap: 8px; }
.ca-confirmed-header__center { flex: 1; text-align: center; }
.ca-confirmed-header__right  { display: flex; align-items: center; gap: 4px; flex-shrink: 0; }
.ca-confirmed-header__title {
  font-size: var(--font-size-6xl);
  font-weight: 700;
  color: var(--text-platform, #ffffff);
}
.ca-success-badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--win);
  color: var(--text-platform);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ca-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-platform, rgba(255,255,255,0.6));
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: color 0.15s, background 0.15s;
}
.ca-icon-btn:hover { color: #ffffff; background: rgba(255,255,255,0.08); }

.ca-confirmed-summary {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  border-top: 1px solid rgba(0,0,0,0.1);
  background: var(--bg-odd-cart);
}
.ca-confirmed-summary__row {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  padding: 14px 10px;
}

.ca-confirmed-summary__label {
  font-size: var(--font-size-3xl);
  color: var(--text-cart, rgba(255,255,255,0.6));
  text-transform: capitalize;
}
.ca-confirmed-summary__value {
  font-size: var(--font-size-7xl);
  font-weight: 900;
  color: var(--text-cart, #ffffff);
}
.ca-confirmed-summary__row--winning .ca-confirmed-summary__label {
  color: var(--text-cart, #ffffff);;
}
.ca-confirmed-summary__value--winning {
  color: var(--text-cart, #ffffff);;
  font-size: var(--font-size-6xl);
}

/* ══════════════════════════════════════════════════════════════════════════ */
/* BET BUILDER GROUP (Illinois/American cart style)                           */
/* ══════════════════════════════════════════════════════════════════════════ */
.cia-bb-group {
  padding: 10px 0 6px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}
.cia-bb-group:last-child {
  border-bottom: none;
}
.cia-bb-label {
  display: flex;
  align-items: center;
  gap: 0px;
  font-size: var(--font-size-xl);
  font-weight: 800;
  font-style: italic;
  text-transform: uppercase;
  color: var(--text-cart, #1a1a1a);
  letter-spacing: 0.06em;
  margin-bottom: 8px;
}
.cia-bb-event-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}
.cia-bb-remove {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: var(--text-cart, #1a1a1a);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  transition: color 0.15s;
}
.cia-bb-remove:hover { color: var(--danger, #ef4444); }
.cia-bb-event-name {
  flex: 1;
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--text-cart, #1a1a1a);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cia-bb-odd {
  font-size: var(--font-size-4xl);
  font-weight: 800;
  color: var(--text-cart, #1a1a1a);
  flex-shrink: 0;
}
.cia-bb-unavailable {
  font-size: var(--font-size-2xl);
  font-weight: 600;
  color: var(--text-op-50-platform, rgba(0,0,0,0.5));
  flex-shrink: 0;
}
.cia-bb-timeline {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cia-bb-row {
  position: relative;
  display: flex;
  align-items: flex-start;
}
.cia-bb-row:not(.cia-bb-row--last)::before {
  content: "";
  position: absolute;
  left: -12px;
  top: 16px;
  bottom: -10px;
  width: 1px;
  background: rgba(0,0,0,.18);
}
.cia-bb-dot {
  position: absolute;
  left: -16px;
  top: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1.5px solid var(--color-accent, var(--color-primary));
  background: transparent;
}
.cia-bb-content {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.cia-bb-outcome {
  font-size: var(--font-size-3xl);
  font-weight: 700;
  color: var(--color-accent, var(--color-primary));
  word-break: break-word;
}
.cia-bb-market {
  font-size: var(--font-size-2xl);
  font-weight: 600;
  color: var(--text-cart, #1a1a1a);
}
.cia-bb-row--redundant {
  justify-content: space-between;
  gap: 8px;
}
.cia-bb-row--redundant .cia-bb-outcome {
  color: var(--v-warning-base, #fb8c00);
  text-decoration: line-through;
}
.cia-bb-redundant-leg-hint {
  display: flex;
  align-items: center;
  font-size: var(--font-size-xl);
  font-weight: 500;
  color: var(--v-warning-base, #fb8c00);
}
.cia-bb-redundant-leg-remove {
  flex-shrink: 0;
}
.cia-bb-retry-btn {
  margin-left: 8px;
  padding: 1px 8px;
  font-weight: 600;
  border: 1px solid currentColor;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.cia-bb-redundant-hint {
  display: flex;
  align-items: center;
  font-size: var(--font-size-xl);
  font-weight: 500;
  color: var(--v-warning-base, #fb8c00);
  margin-top: 8px;
  padding-left: 4px;
}
</style>
